import { Controller } from '@hotwired/stimulus';
import { leave, toggle } from 'el-transition';

// Connects to data-controller="navigation--dropdown"
export default class extends Controller {
  static targets = ['button', 'menu'];

  toggle() {
    if (this.hasMenuTarget) {
      toggle(this.menuTarget);
    }
  }

  close(event) {
    if (!this.buttonTarget.contains(event.target)) {
      leave(this.menuTarget);
    }
  }
}
